import styled from "styled-components";
import { Link } from "react-router-dom";
import { BiUpArrowAlt, BiDownArrowAlt } from "react-icons/bi";

const Tabela = styled.table`
    width: 90%;
    justify-content: center;
    text-align: center;
    border-collapse: collapse;
    margin: auto;
    margin-top: 10px;
    overflow-x: auto;
    margin-bottom: 20px;
`
const TituloColunas = styled.th`
    cursor: pointer;
    p {
        display: flex;
        flex: 1 1 auto;
        justify-content: center;
        margin: 0;
        color: #252525;
    }
    .Icone {
        position: relative;
        top: 4px;
        left: 3px;
        margin: 0 2px;
        padding: 0;
    }
`
const LinhaTabela = styled.tr`
    border-bottom: 1px solid lightgray;
    border-top: ${props => props.$linha || "none"};
    height: 30px;
    color: ${props => props.$cor || "inherit" };

    td {
        padding-top: ${props => props.$espaco || "none"};
        padding-bottom: ${props => props.$espaco || "none"};
    }
`
const ColunaTabela = styled.td`
    width: ${props => props.$tamanho || "auto"};
`
export function TabComissoesManuais(comissoes, totais, ordenacaoAtual, ordemAtual, setOrdenacaoAtual, setOrdemAtual, selecionados, setSelecionados, selecionadosPagina, setSelecionadosPagina, totalSelecionado, setTotalSelecionado) {
    try {
        const campos = [
            {chave: "guia", label: "Guia"},
            {chave: "comissaoTotal", label: "Valor"},
            {chave: "dataPagamento", label: "Pagamento"},
            {chave: "pagamentoEfetivado", label: "Efetivado"},
            {chave: "mensagem", label: "Mensagem"}
        ];

        function atualizaOrdemOrdenacao(ordenacao){
            if (ordenacaoAtual === ordenacao){
                setOrdemAtual(ordemAtual === 1? -1 : 1);
            } else {
                setOrdenacaoAtual(ordenacao);
                setOrdemAtual(1);
            }
        }

        function atualizaSelecionados(id, valor) {
            if (selecionados.includes(id)) {
                setSelecionados(selecionados.filter((item) => item !== id));
                setTotalSelecionado(totalSelecionado -= valor);
                setSelecionadosPagina(selecionadosPagina - 1);
            } else {
                setSelecionados([...selecionados, id]);
                setTotalSelecionado(totalSelecionado += valor);
                setSelecionadosPagina(selecionadosPagina + 1);
            }
        }

        function selecionaTudo() {
            let novosSelecionados = selecionados;
            
            // Verifica se está tudo selecionado na página
            if (selecionadosPagina === comissoes.length) {
                comissoes.forEach( com => {
                    if (selecionados.includes(com.identificador)){
                        novosSelecionados = novosSelecionados.filter( item => item !== com.identificador );
                        setTotalSelecionado(totalSelecionado -= com.comissaoTotal);
                        // setSelecionados(selecionados.filter( item => item !== com.identificador));
                    }
                });
                setSelecionados(novosSelecionados);
                setSelecionadosPagina(0);
            } else {
                comissoes.forEach( com => {
                    if (!selecionados.includes(com.identificador)) {
                        selecionados.push(com.identificador);
                        setTotalSelecionado(totalSelecionado += com.comissaoTotal);
                    }
                })
                setSelecionadosPagina(comissoes.length);
            }
        }

        return (
            <Tabela>
                <thead>
                    <LinhaTabela>
                        <TituloColunas><input type="checkbox" checked={selecionadosPagina === comissoes.length} onChange={() => selecionaTudo()}/></TituloColunas>
                        {campos.map( campo => {
                            return <TituloColunas key={campo.chave} onClick={() => atualizaOrdemOrdenacao(campo.chave)}>
                                <p>
                                    {campo.label}
                                    {campo.chave === ordenacaoAtual && ordemAtual === -1 && <BiUpArrowAlt className="Icone" size={'1em'}/>}
                                    {campo.chave === ordenacaoAtual && ordemAtual === 1 && <BiDownArrowAlt className="Icone" size={'1em'}/>}
                                </p>
                            </TituloColunas>
                        })}
                    </LinhaTabela>
                </thead>
                <tbody>
                    {comissoes.map((comissao, index) => {
                        let comTot = comissao.comissaoTotal.toFixed(2).split(".");
                        return (
                        <LinhaTabela key={comissao.identificador || index}> 
                            <ColunaTabela><input 
                                type="checkbox" 
                                checked={selecionados.includes(comissao.identificador)} 
                                onChange={ () => atualizaSelecionados(comissao.identificador, comissao.comissaoTotal)}
                            /></ColunaTabela>
                            <ColunaTabela><Link style={{ textDecoration: 'none', color: "inherit", cursor: "pointer" }} to={`/admin/guias/${comissao.guia._id}`}>{comissao.guia.nome}</Link></ColunaTabela>
                            <ColunaTabela>R$ {comTot[0]},{comTot[1]}</ColunaTabela>
                            <ColunaTabela>{comissao.dataPagamento.slice(8, 10)}/{comissao.dataPagamento.slice(5, 7)}/{comissao.dataPagamento.slice(0, 4)}</ColunaTabela>
                            <ColunaTabela>{comissao.pagamentoEfetivado? "Sim" : "Não"}</ColunaTabela>
                            <ColunaTabela>{comissao.mensagem}</ColunaTabela>
                        </LinhaTabela>
                    )})}
                    <LinhaTabela $cor="#007396" $linha={"1px solid lightgray"} $espaco={"10px"}>
                        <ColunaTabela></ColunaTabela>
                        <ColunaTabela>Valor total da página</ColunaTabela>
                        <ColunaTabela>R$ {totais.totalTotal.split(".")[0]},{totais.totalTotal.split(".")[1]}</ColunaTabela>
                    </LinhaTabela>
                    <LinhaTabela $cor="#007396" $linha={"1px solid lightgray"} $espaco={"10px"}>
                        <ColunaTabela></ColunaTabela>
                        <ColunaTabela>Valor total selecionado</ColunaTabela>
                        <ColunaTabela>{new Intl.NumberFormat("pt-BR", {
                            style: "currency",
                            currency: "BRL"
                        }).format(totalSelecionado || 0)}</ColunaTabela>
                    </LinhaTabela>
                </tbody>
            </Tabela>
        )
    } catch (e) {
        return <></>
    }
}